import React from "react";
import notFoundImg from "../assets/icons/404Icon.png";
import { Link, useLocation } from "react-router-dom";
import { FaTools, FaArrowLeft } from "react-icons/fa";

const NotFoundPage = () => {
  return (
    <div style={styles.container}>
      <div style={styles.icon}>
        <img src={notFoundImg} />
      </div>
      <h1 style={styles.code}>404</h1>
      <h2 style={styles.message}>Page Not Found</h2>
      <p style={styles.subMessage} className="mx-4">
        The resource requested could not be found on this server!
      </p>
      <Link to={-1} className="btn  btn-outline-dark mt-3">
        <FaArrowLeft className="me-2" />
        Go Back
      </Link>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f8f9fa",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    textAlign: "center",
  },
  icon: {
    fontSize: "40px",
    marginBottom: "10px",
  },
  code: {
    fontSize: "72px",
    fontWeight: "bold",
    color: "#3e3e3e",
    margin: "0",
  },
  message: {
    fontSize: "19px",
    color: "#333",
    margin: "10px 0",
    fontWeight: "bolder",
  },
  subMessage: {
    fontSize: "14px",
    color: "#666",
    //  fontWeight : "bold",
  },
};

export default NotFoundPage;
